import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faImage } from '@fortawesome/pro-regular-svg-icons/faImage'

export const defaultTranslations = {
    pluginName: 'Image',
    pluginDescription: 'Insert an image.',
}

export const defaultSettings = {
    Controls: () => <>Controls for this plugin were not provided</>,
    Renderer: () => <>Renderer for this plugin was not provided</>,
    translations: defaultTranslations,
    IconComponent: <FontAwesomeIcon icon={faImage} size="3x" />,
}
